import React,{useState} from "react";
import { Link } from "react-router-dom";

import image1 from '../assets/images/portfolio/attendance_mgmt_sys.jpg'
import image2 from '../assets/images/portfolio/complaint_mgmt_sys.jpg'
import image3 from '../assets/images/portfolio/property_mgmt_sy.jpg'
import image4 from '../assets/images/portfolio/online_client_portal.jpg'
import image5 from '../assets/images/portfolio/vehicle_tracking_sys.jpg'
import image6 from '../assets/images/portfolio/ecommerce_sites.jpg'
import image7 from '../assets/images/portfolio/supply_chain_mgmt_system.jpg'
import image8 from '../assets/images/portfolio/ndc_transfer.jpg'
import image9 from '../assets/images/portfolio/sms_notification_integration.jpg'
import image10 from '../assets/images/portfolio/api_development.jpg'
import image11 from '../assets/images/portfolio/modular_erp.jpg'
import icon_live_website from '../assets/images/icons/live_website.png'
import logo_firebase from "../assets/images/logos/firebase.png"
import logo_react from "../assets/images/logos/react.png"
import logo_java from "../assets/images/logos/java.png"
import logo_laravel from "../assets/images/logos/laravel.png"
import logo_october from "../assets/images/logos/october.png"
import logo_python from "../assets/images/logos/logo_python.png"
import logo_mysql from "../assets/images/logos/logo_mysql.png"
import logo_sqllite from "../assets/images/logos/logo_sqllite.png"
import logo_map from "../assets/images/logos/logo_map.png"
import logo_git from "../assets/images/logos/logo_git.png"
import logo_paypal from "../assets/images/logos/paypal.png"
import logo_stripe from "../assets/images/logos/stripe.png"
import logo_twilio from "../assets/images/logos/logo_twilio.png"
import logo_elementor from "../assets/images/logos/elementor.png"
import logo_figma from "../assets/images/logos/figma.png"


import Lightbox from 'react-18-image-lightbox';
import "react-18-image-lightbox/style.css"

import {FiCamera} from "../assets/icons/vander"

export default function OurProjects({containerFuild}){
    
    const images = [image1, image2, image3,image4, image5, image6, image7, image8, image9, image10, image11]

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isOpen, setisOpen] = useState(false);

    const handleMovePrev = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + images.length - 1) % images.length);
    };

    const handleMoveNext = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    };
    const handleImageClick = (index) => {
        setCurrentImageIndex(index);
        setisOpen(true);
    };
    const currentImage = images[currentImageIndex];

    const projectData = [
        {
            id:0,
            image:image1,
            title:'Employee Attendance System',            
            description:'An Android-based Employee Attendance System utilizing Suprema fingerprint devices, developed in Java. It ensures accurate attendance tracking, enhances security, streamlines task management, and improves attendance management for organizations efficiently',
            category:"websites",
            stack:[logo_java,logo_laravel,logo_mysql,logo_firebase,logo_map,logo_git]

        },
        {
            id:1,
            image:image2,
            title:'Complaint Management System',
            description:'A Complaint Management System for Defence Housing Authority (DHA) enabling users to submit complaints via mobile, featuring SOS panic buttons for emergencies, online bill payments, and efficient domestic staff management',
            category:"mobileapps",
            stack:[logo_react,logo_laravel,logo_firebase,logo_sqllite,logo_map,logo_git]
        },
        {
            id:2,
            image:image3,
            title:'Property Management System',
            description:'A Property Management System that manages both rental and sale properties, facilitates payment processing, tracks tenant information, and streamlines communication between landlords and tenants for efficient property oversight',
            category:"photography",
            stack:[logo_react,logo_python,logo_firebase,logo_october,logo_git,logo_mysql]
        },
        {
            id:3,
            image:image4,
            title:'Online Client Portal',
            description:'An Online Client Portal that provides secure access for users, featuring account management, document sharing, communication tools, project tracking, and real-time updates to enhance client engagement and streamline interactions',
            category:"ui_ux",
            stack:[logo_react,logo_python,logo_mysql,logo_firebase,logo_git,logo_sqllite,logo_twilio]
        },
        {
            id:4,
            image:image5,
            title:'Vehicle Tracking System',
            description:'A real-time tracking of vehicles and equipment, optimizing fleet performance, managing maintenance schedules, and ensuring efficient resource allocation for enhanced operational efficiency',
            category:"websites",
            stack:[logo_java,logo_firebase,logo_map,logo_git,logo_sqllite]
        },
        {
            id:5,
            image:image6,
            title:'Ecommerce Webites',
            description:'ECommerce websites with top features including user-friendly navigation, secure payment gateways, mobile responsiveness, product management, SEO optimization, and integrated analytics to enhance the shopping experience and drive sales',
            category:"websites",
            stack:[logo_laravel,logo_october,logo_mysql,logo_firebase,logo_paypal,logo_stripe,logo_elementor]
        },
        {
            id:6,
            image:image7,            
            title:'Supply Chain Management Sys',
            description:'It involves inventory management, order processing, and logistics tracking, enhancing visibility and collaboration across the supply chain to optimize efficiency and reduce operational costs',
            category:"mobileapps",
            stack:[logo_react,logo_python,logo_sqllite,logo_firebase,logo_git,logo_map,logo_stripe]
        },
        {
            id:7,
            image:image8,
            title:'Ndc / Transfers & Records System',
            description:'A Property System utilizes fingerprint verification for secure property transactions and efficiently manages the transfer and recording of property records, ensuring accuracy and transparency in property ownership',
            category:"ui_ux",
            stack:[logo_java,logo_laravel,logo_mysql,logo_firebase,logo_git]
        },
        {
            id:8,
            image:image9,
            title:'SMS / Email Notification Integration',
            description:'Integrate SMS and notification systems to enhance user authentication (OTP), delivering real-time alerts, reminders, and updates, ensuring timely communication and improving overall user experience and satisfaction',
            category:"photography",
            stack:[logo_october,logo_react,logo_twilio,logo_firebase,logo_laravel,logo_git]
        },
        {
            id:9,
            image:image10,
            title:'Api Development & Integration', 
            description:'Handle complex APIs for mobile applications, enabling real-time data synchronization, third-party integrations, secure authentication, and scalable architecture, ensuring seamless user experiences and robust functionality across diverse platforms',
            category:"photography",
            stack:[logo_react,logo_laravel,logo_firebase,logo_mysql,logo_git]
        },
        {
            id:10,
            image:image11,
            title:'Flexible Modular ERP',
            description:'Modular ERP Dashboard offers customizable modules for finance, inventory, sales, and human resources, providing real-time analytics, seamless integration, and user-friendly interfaces to enhance decision-making and operational efficiency',
            category:"websites",
            stack:[logo_react,logo_python,logo_mysql,logo_firebase,logo_sqllite,logo_twilio,logo_figma]
        },
    ]
    const matchCategory = (category) => {
        setSelectedCategory(category);
    };
    const filteredData = selectedCategory
    ? projectData.filter((item) => item.category === selectedCategory)
    : projectData;
    return(
        <>
         <div className="relative md:mt-24 mt-16">
                <div className="grid grid-cols-1 pb-6 text-center">
                    <h3 className="mb-6 md:text-2xl text-xl font-medium">My Projects</h3>

                    <p className="text-slate-400 dark:text-white/60 max-w-xl mx-auto">Discover the Designs and Solutions I’ve Crafted, Helping Clients Achieve Their Goals and Visions
                    </p>
                </div>

                {/* <div className=" container grid grid-cols-1 items-center mt-6 gap-6">
                    <div className="filters-group-wrap text-center">
                        <div className="filters-group">
                            <ul className="mb-0 list-none container-filter filter-options space-x-3">
                                <li className={`${selectedCategory === null ? "active" : "" } inline-block font-medium text-[15px] mb-3 text-slate-400 cursor-pointer relative duration-500`} data-group="all" onClick={() => matchCategory(null)}>All</li>
                                <li className={`${selectedCategory === "websites" ? "active" : "" } inline-block font-medium text-[15px] mb-3 text-slate-400 cursor-pointer relative duration-500`} data-group="websites" onClick={() => matchCategory("websites")}>Web</li>
                                <li className={`${selectedCategory === "mobileapps" ? "active" : "" } inline-block font-medium text-[15px] mb-3 text-slate-400 cursor-pointer relative duration-500`} data-group="mobileapps" onClick={() => matchCategory('mobileapps')} >Mobile Apps</li>
                                <li className={`${selectedCategory === "ui_ux" ? "active" : "" } inline-block font-medium text-[15px] mb-3 text-slate-400 cursor-pointer relative duration-500`} data-group="ui_ux" onClick={() => matchCategory('ui_ux')}>UI UX</li>
                            </ul>
                        </div>
                    </div>
                </div> */}

              {containerFuild ? 
                <div className="container-fluid relative">
                    <div id="grid" className="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-1 mt-4 gap-[30px] lg:px-6 px-4">
                    {filteredData.map((item,index)=>{
                        return(
                        <div className="picture-item" data-groups='["branding"]' key={index}>
                            <div className="group relative block rounded-xl duration-700 ease-in-out">
                                <div className="relative overflow-hidden rounded-xl">
                                    <Link to="" className="lightbox" title="">
                                        <img src={item.image} className="rounded-xl" alt=""/>
                                    </Link>
                                </div>
                                <div className="content duration-700 ease-in-out">
                                    <div className="bg-white dark:bg-slate-900 p-4 rounded-xl absolute z-10 bottom-3 start-3 duration-700 ease-in-out scale-0 group-hover:scale-100">
                                        <Link to="#!" className="h6 text-[15px] font-medium hover:text-orange-500 duration-500 ease-in-out">{item.title}</Link>
                                        <p className="text-slate-400 dark:text-white/60 mb-0 mt-2 text-sm">{item.description}</p>
                                        {item.stack&&
                                            <div className="mt-5 mb-2">
                                                <ul className="d-flex">
                                                    {item.stack.map((logo, stackIndex) => (
                                                        <li key={stackIndex} className="me-3">
                                                            <img src={logo} alt={`Logo ${stackIndex + 1}`} className="w-6"/>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                    
                                </div>

                                <div className="absolute inset-0 bg-orange-500 rounded-xl group-hover:-mt-[10px] group-hover:-ms-[10px] h-[98%] w-[98%] duration-700 -z-1"></div>
                            </div>
                        </div>
                        )
                    })}
                        <div className="picture-item py-16 d-grid rounded-xl h-[100%] w-[100%] bg-live-website items-center">
                            <div className="group relative block rounded-xl duration-700 ease-in-out">
                                <div className="relative overflow-hidden rounded-xl text-center">
                                    <Link to="/live-websites"  className="lightbox" title="">
                                        <img src={icon_live_website} className="w-28 rounded-xl mx-auto my-3 pulse-icon" alt=""/>
                                    </Link>
                                    <Link to="/live-websites" className="h6 text-[20px] font-medium hover:text-orange-500 duration-500 ease-in-out">
                                    <span className="text-white ">Check Live Websites</span>
                                    </Link>
                                </div>
                                {/* <div className="absolute inset-0 bg-gray-900 rounded-xl group-hover:-mt-[10px] group-hover:-ms-[10px] h-[100%] w-[100%] duration-700 -z-1"></div> */}
                            </div>
                        </div>
                        {isOpen && (
                                    <Lightbox
                                        mainSrc={currentImage}
                                        prevSrc={images[(currentImageIndex + images.length - 1) % images.length]}
                                        nextSrc={images[(currentImageIndex + 1) % images.length]}

                                        onCloseRequest={() => setisOpen(false)}
                                        onMovePrevRequest={handleMovePrev}
                                        onMoveNextRequest={handleMoveNext}
                                    />
                                )}
                    </div>
                </div> :
                <div className="container relative">
                    <div id="grid" className="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-1 mt-4 gap-[30px]">
                    {filteredData.map((item,index)=>{
                        return(
                        <div className="" data-groups='["websites"]' key={index}>
                            <div className="group relative block rounded-xl duration-700 ease-in-out">
                                <div className="relative overflow-hidden rounded-xl">
                                    <Link to="" onClick={() => handleImageClick(item.id)} className="lightbox" title="">
                                        <img src={item.image} className="rounded-xl" alt=""/>
                                    </Link>
                                </div>
                                <div className="content duration-700 ease-in-out">
                                    <div className="bg-white dark:bg-slate-900 p-4 rounded-xl absolute z-10 bottom-3 start-3 duration-700 ease-in-out scale-0 group-hover:scale-100">
                                        <Link to="/portfolio-detail-three" className="h6 text-[15px] font-medium hover:text-orange-500 duration-500 ease-in-out">Mockup Collection</Link>
                                        <p className="text-slate-400 dark:text-white/60 mb-0">Abstract</p>
                                    </div>
                                </div>

                                <div className="absolute inset-0 bg-orange-500 rounded-xl group-hover:-mt-[10px] group-hover:-ms-[10px] h-[98%] w-[98%] duration-700 -z-1"></div>
                            </div>
                        </div>
                        )
                    })}
                        {isOpen && (
                                    <Lightbox
                                        mainSrc={currentImage}
                                        prevSrc={images[(currentImageIndex + images.length - 1) % images.length]}
                                        nextSrc={images[(currentImageIndex + 1) % images.length]}

                                        onCloseRequest={() => setisOpen(false)}
                                        onMovePrevRequest={handleMovePrev}
                                        onMoveNextRequest={handleMoveNext}
                                    />
                                )}
                    </div>
                </div>
              }
            </div>
        </>
    )
}